<template>
    <div class="container-fluid">

        <form class="form-inline" @submit.prevent="fetch_graph_data">
            <b-row class="row m-1">
                <b-form-group :state="validateState('start_date')"> 
                 <span class="mr-3">A partir du </span>  
                    <b-form-input  v-model="selected_start_date" 
                            :state="validateState('start_date')"
                            type="date" class="form-control w-auto pointer" required :max="today">
                    </b-form-input>
                </b-form-group>

                <b-form-group :state="validateState('end_date')"> 
                    
                 <span class="mr-3  ml-4 text-center">au </span>  
                    <b-form-input  v-model="selected_end_date" 
                            :state="validateState('end_date')"
                            type="date" class="form-control w-auto pointer" required :max="today"> 
                    </b-form-input>
                </b-form-group>


                <div class="mr-3 ml-3"> </div> <!--  select extraction type  -->
                <b-form-group
                    v-if="!_props.subscriptionOK && !_props.system.name && !_props.sensor.name"
                    class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select  id="selectedBy"
                        class= "custom-select form-control w-auto pointer"
                        v-model="selected_by"
                        style="background-color:#d4d4d4"
                        required>
                        <!-- selected_by_code  <b-form-select-option disabled value="">Choisissez un type d'extraction</b-form-select-option> -->
                        <b-form-select-option v-bind:value="'sensors'" v-bind:key="'sensors'">
                            {{ 'compteurs' }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group> 

                <b-form-group
                    v-if="_props.subscriptionOK && !_props.system.name && !_props.sensor.name"
                    class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select  id="selectedBy"
                        class="custom-select form-control w-auto pointer"
                        v-model="selected_by"
                        required>
                        <b-form-select-option disabled value="">Type d'extraction</b-form-select-option>
                        <b-form-select-option v-for="sBy in selectedBy" v-bind:value="sBy.name" v-bind:key="sBy.name">
                            {{ sBy.nom }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group> 

                <div class="ml-3 mr-3" v-if="selected_by == 'sensors' && !_props.system.name && !_props.sensor.name"> </div>
                <b-form-group
                            v-if="!_props.sensor.name" 
                            :state="validateState('sensor')" 
                            class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select 
                            v-model="selected_by_id.sensor"
                            :state="validateState('sensor')" 
                            v-if="selected_by == 'sensors'"
                            class="custom-select form-control w-auto pointer"
                            required>
                            <b-form-select-option disabled value="null">Choisir un compteur</b-form-select-option>
                            <b-form-select-option v-for="sensor in sensors" v-bind:value="sensor.id" v-bind:key="sensor.id">
                                {{sensor.name}}
                            </b-form-select-option>
                    </b-form-select> 
                </b-form-group> 

                <div class="ml-3 mr-3" v-if="selected_by == 'systems' && !_props.system.name && !_props.sensor.name"> </div>
                <b-form-group
                            v-if="!_props.system.name" 
                            :state="validateState('system')" 
                            class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select 
                            v-model="selected_by_id.system"
                            :state="validateState('system')" 
                            v-if="selected_by == 'systems'"
                            class="custom-select form-control w-auto pointer"
                            required>
                            <b-form-select-option disabled value="null">Choisir un outil</b-form-select-option>
                            <b-form-select-option v-for="system in systems" v-bind:value="system.id" v-bind:key="system.id">
                                {{system.name}} - Code : {{system.code}}
                            </b-form-select-option>
                    </b-form-select> 
                </b-form-group> 

                <b-form-group>
                    <select class="custom-select" v-model="graph_rq_option.groupping_option">
                        <option value="default" disabled>Regroupement des données</option>
                        <option value="without" selected>Données brutes</option>
                        <option value="activity" disabled v-if="this.selected_by == 'systems'">Par phase d'activité</option>
                        <option value="hourly" v-if="this.selected_by == 'systems'">Par Heures</option>
                        <option value="daily" v-if="this.selected_by == 'systems'">Par Jours</option>
                    </select>
                </b-form-group> 
                
                <div class="" v-if="!_props.system.name && !_props.sensor.name"> </div>
                    <button 
                        type="submit" 
                        class="btn btn-primary text-center m-4 mr-4 w-auto"
                        margin="5px"
                        :disabled="hasErrors"
                        :class="{disabled:hasErrors}"> 
                        
                        Récupération des données 
                    </button>

                  <!--  <div v-on:click="resetValues()" class="btn btn-danger m-auto w-auto" :title="[_props.system.name ? 'Réinitialiser les dates' : 'Réinitialiser les valeurs']"> <i class="ti-close"></i></div>
              -->
            </b-row>
        </form>
        
        <div class="col-md-12" v-if="data_avaible">
            <select class="custom-select" v-model="graph_type">
                <option :disabled="graph_rq_option.groupping_option == 'activity'" selected value="line">Graphes</option>
                <option value="donut">Résumé de l'utilisation</option>     
            </select>

            <span>&nbsp;</span>

            <div v-if="graph_type == 'line'" class="col-md-12">
                <v-graph1 ref="line_chart" id="line_chart" type="line" :options="options1" :series="series1"></v-graph1>
            </div>

            <div v-else-if="graph_type == 'donut'" class="row align-middle">
                <div class="col-md-6 align-middle">
                    <v-graph2 id="donut_chart_1" type="donut" :options="options2" :series="series2"></v-graph2>
                </div>
                <div class="col-md-6 align-middle">
                    <v-graph3 id="donut_chart_2" type="donut" :options="options3" :series="series3"></v-graph3>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

import api from "../../config/_api";
import { mapGetters } from 'vuex';
import VueApexCharts from 'vue-apexcharts';

const date = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
//https://apexcharts.com/docs/options/xaxis/

export default {
        name: 'Graph',
        components: {
            'v-graph1' : VueApexCharts,
            'v-graph2' : VueApexCharts,
            'v-graph3' : VueApexCharts,
        },
        data () {
            var self = this;
            return {
                selectedBy:[
                    {name:"sensors", nom:"compteurs"},
                    {name:"systems", nom:"outils"},
                ],
                today : null,
                start_date : null,
                isBusy : false,
                api_url : api.url,
                selected_start_date: "",
                selected_end_date: "",
                selected_by: "",
                graph_rq_option:{
                    groupping_option: "default",
                },
                request_from_user: 1,
                error:false,              
                selected_by_id: {
                    sensor: null,
                    system: null,
                    adherent: null
                },
                validation : {
                    start_date : {
                        $dirty : true,
                        $error : false,
                        required : false,
                        date : false ,
                        before : false,
                    },
                    end_date : {
                        $dirty : true,
                        $error : false,
                        required : false,
                        date : false ,
                        after : false,
                    },
                    system :{
                        $error : true,
                        required : true,
                    },
                    sensor :{
                        $error : true,
                        required : true,
                    },
                    adherent :{
                        $error : true,
                        required : true,
                    },
                    groupping_option :{
                        $error : true,
                        required : true,
                    }
                },
                data_avaible : false,
                graph_type : "line",
                options1: {
                    chart: {
                        type: 'line',
                        stacked: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        width: [1, 1, 4]
                    },
                    title: {
                        text: 'Données d\'utilisation',
                        align: 'left',
                        offsetX: 10
                    },
                    xaxis: {
                        type: 'datetime',
                        labels: {
                            rotate : 20,
                            rotateAlways: false,
                            hideOverlappingLabels: true,
                            showDuplicates: false,
                            trim: true,
                            offsetX: 7,
                            formatter: function(value, timestamp, opts) {
                                //return opts.dateFormatter(new Date(timestamp), 'dd MMM');
                                return new Date(timestamp).toLocaleString('fr-FR', { day: "numeric", month:'short' });
                            },

                        },
                        tooltip: {
                            formatter: function(value, opts) {
                                return self.tooltipFormatter(value, opts);
                            },
                        },
                        tickPlacement : 'between' //'between' ou on
                    },
                    yaxis: [
                        {
                            seriesName: 'Temps d\'utilisation',
                            opposite: true,
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                                color: '#008FFB'
                            },
                            labels: {
                                style: {
                                    colors: '#008FFB',
                                }
                            },
                            title: {
                                text: "Temps d'utilisation (h)",
                                style: {
                                    color: '#008FFB',
                                }
                            },
                            min : 0,
                            max : 100
                        }
                    ],
                    tooltip: {
                        /*fixed: {
                            enabled: true,
                            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                            offsetY: 30,
                            offsetX: 90
                        },*/
                        followCursor : true,
                        //fillSeriesColor : true,   //moche

                        x: {
                            show: true,
                            formatter: function(value, opts) {
                                return self.tooltipFormatter(value, opts);
                            },
                        }
                    },
                    legend: {
                        horizontalAlign: 'center',
                        //offsetY: 10,
                        //offsetX: 40
                    }
                },
                series1: [{
                    name: 'Temps d\'utilisation',
                    type: 'line',
                    data: [],
                    style: {
                        colors: '#00E396',
                    }
                }],
                series2: [44, 55],
                options2: {
                    labels : ["Période non réservée","Période réservée"],
                    chart: {
                        type: "donut",
                        width: 300
                    },
                    pie: {
                        size : 200,
                        startAngle: -90,            //angle de départ si fonctionnement en cercle non complet
                        endAngle: 90,
                        offsetY: 10,        // décallage en Y du graph par rapport à la légende
                        donut: {
                            size: "65%"     //taile du trou dans le centre du donut
                        },
                        expandOnClick: false
                    },
                    responsive: [{
                        breakpoint: 1200,    //conditin en px pour que l'option de base soit remplacer par celle qui suit
                        options: {
                            chart: {
                                width: 100
                            },
                            pie: {
                                offsetY: 3000
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
                series3: [44, 55, 41],
                options3: {
                    labels : ["Durée réservée sans utilisation","Utilisation allouée","Utilisation non allouée"],
                    chart: {
                        type: "donut",
                        width: 300
                    },
                    pie: {
                        size : 200,
                        startAngle: -90,            //angle de départ si fonctionnement en cercle non complet
                        endAngle: 90,
                        offsetY: 10,        // décallage en Y du graph par rapport à la légende
                        donut: {
                            size: "65%"     //taile du trou dans le centre du donut
                        },
                        expandOnClick: false
                    },
                    responsive: [{
                        breakpoint: 1200,    //conditin en px pour que l'option de base soit remplacer par celle qui suit
                        options: {
                            chart: {
                                width: 100
                            },
                            pie: {
                                offsetY: 3000
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
            };
        },
        props: {
            subscriptionOK : {
                type : Boolean,
                required: true,
            },
            system: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                        code: "",
                    }
                }
            },
            sensor: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                    }
                }
            },
            adherent: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        lastname: "",
                        code: "",
                    }
                }
            },
            start_date_arg: "",
        },
        computed: {
			...mapGetters({
                structure : 'structure/structure'
			}),
            hasErrors () {
                return this.validation['start_date'].$error 
					|| this.validation['end_date'].$error 
                    || (this.validation['system'].$error
                    && this.validation['sensor'].$error)
                    || this.validation['groupping_option'].$error ;
            },
		},
        mounted() {            
            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 250);
            this.setSystemId();
            this.setSensorId();
            this.setAdherentId();
            this.setDefaultFormInput(); //bien appeler après avoir set les autres parties car l'affichage dépends de ce par quoi on extrait
        },

        watch :{
            selected_start_date(){
                this.data_avaible = false;
                this.validation['start_date'].required = this.selected_start_date == '';
                this.validation['start_date'].date=date.exec(this.selected_start_date) == null;

                this.validation['start_date'].before = new Date(this.selected_start_date) > new Date(this.selected_end_date);
				this.validation['end_date'].after = new Date(this.selected_end_date) < new Date(this.selected_start_date);

                this.validation['start_date'].$error = this.validation['start_date'].required || this.validation['start_date'].before || this.validation['start_date'].date;
				this.validation['end_date'].$error = this.validation['end_date'].required || this.validation['end_date'].after || this.validation['end_date'].date;
            },
            selected_end_date(){
                this.data_avaible = false;
                this.validation['end_date'].required = this.selected_end_date == '';
                this.validation['end_date'].date=date.exec(this.selected_end_date) == null;

                this.validation['start_date'].before = new Date(this.selected_start_date) > new Date(this.selected_end_date);
				this.validation['end_date'].after = new Date(this.selected_end_date) < new Date(this.selected_start_date);

				this.validation['end_date'].$error = this.validation['end_date'].required || this.validation['end_date'].after || this.validation['end_date'].date;
                this.validation['start_date'].$error = this.validation['start_date'].required || this.validation['start_date'].before || this.validation['start_date'].date;
            },

            "selected_by_id.system"(){
                this.validation['system'].required = this.selected_by_id.system == null ;
                this.validation['system'].$error = this.validation['system'].required;
            },
            "selected_by_id.sensor"(){
                this.validation['sensor'].required = this.selected_by_id.sensor == null ;
                this.validation['sensor'].$error = this.validation['sensor'].required;
            },

            "graph_rq_option.groupping_option"(){
                this.data_avaible = false;
                this.validation['groupping_option'].$error = this.graph_rq_option.groupping_option == "default";
            },
        },

        methods: {
            updateSelectedBySensor(){
                if(!this.subscriptionOK){
                    this.selected_by = "sensors"
                }
            },
			validateState(name) {
				const { $dirty, $error } = this.validation[name];
				return $dirty ? !$error : null;
			},
            invalidFeedback(){
                if(this.validation['start_date'].before || this.validation['end_date'].after) {
					return 'La date de début doit être une date antérieure à la date de fin'
				} 
            },
            setDefaultFormInput(){

                let date= new Date();
                var dd = date.getDate(); 
                var mm = date.getMonth() + 1; 
                var yyyy = date.getFullYear(); 
                if (dd < 10) { 
                    dd = '0' + dd; 
                } 
                if (mm < 10) { 
                    mm = '0' + mm; 
                } 
                var today = yyyy + '-' + mm + '-' + dd;

                this.selected_end_date=today;
                this.today=today;

                if(this.start_date_arg<this.today){
                    this.start_date=this.start_date_arg;
                    this.selected_start_date=this.start_date_arg;
                }
                else{
                    this.start_date = new Date(this.today);
                    var day = this.start_date.getDay();
                    var diff = this.start_date.getDate() - day + (day == 0 ? -6:1) -7; // adjust when day is sunday
                    this.start_date.setDate(diff);
                    dd = this.start_date.getDate(); 
                    mm = this.start_date.getMonth()+1; 
                    yyyy = this.start_date.getFullYear(); 
                    if (dd < 10) { 
                        dd = '0' + dd; 
                    } 
                    if (mm < 10) { 
                        mm = '0' + mm; 
                    } 
                    this.selected_start_date = yyyy + '-' + mm + '-' + dd;
                }
                if(this.selected_by == "sensors"){
                    this.graph_rq_option.groupping_option = "without";
                }
                else{
                    this.graph_rq_option.groupping_option = "default";
                }
                
            },
            resetValues(){
                this.setDefaultFormInput();
                if(!this.system.name){
                    this.selected_by_id.system=null;
                }
                if(!this.sensor.name){
                    this.selected_by_id.sensor=null;
                }
                if(!this.adherent.lastname){
                    this.selected_by_id.adherent=null;
                }
            },
            setSystemId(){
                if(this.system.name){
                    this.selected_by_id.system=this.system.id;
                    this.selected_by = "systems";
                }
            },
            setSensorId(){
                if(this.sensor.name){
                    this.selected_by_id.sensor=this.sensor.id;
                    this.selected_by = "sensors";
                }
            },
            setAdherentId(){
                if(this.adherent.lastname){
                    this.selected_by_id.adherent=this.adherent.id;
                    this.selected_by = "adherents";
                }
            },
            fetch_graph_data() {
                
                this.data_avaible = false;

                this.isBusy=true;
              //  console.log(this.extractions);

                let data = {
                    selected_start_date: this.selected_start_date,
                    selected_end_date: this.selected_end_date,
                    selected_by: this.selected_by,
                    selected_by_id: 0,
                    selected_by_code : 0
                };

                if(this.selected_by == 'systems'){
                    if(this.system.name){
                        data.selected_by_code = this.system.id;
                    }
                    else{
                        data.selected_by_code = this.selected_by_id.system;
                    }
                }

                else if (this.selected_by == 'sensors'){
                    if(this.sensor.name){
                        data.selected_by_code = this.sensor.id;
                    }
                    else{
                        data.selected_by_code = this.selected_by_id.sensor;
                    }
                }

                var selected_by_id = 0; 

                if(this.selected_by == "systems") {
                    selected_by_id = this.selected_by_id.system;
                }
                else if(this.selected_by == "sensors") {
                    selected_by_id = this.selected_by_id.sensor;
                }

                data.selected_by_id = selected_by_id;

                data.structure_id = this.$store.getters.structure_id

                let date= new Date();
                let nowDate = Date.parse(date); // date actuel en timestamp                
                this.axios({url: api.url + 'structures?id=' + this.$store.getters.structure_id+ '&token='+this.$store.getters.getProfile.api_token, method: 'GET' })
                    .then(function (resp) {

                        let endingDate = Date.parse(resp.data[0].contract_ending_date); // date de fin d'abonnement en timestamp                        
                        if ( endingDate >= nowDate && nowDate !== null) 
                        {
                            var dataJson = JSON.stringify(data);
                            dataJson = dataJson.substring(1);
                            dataJson = dataJson.slice(0,-1);
                            dataJson = dataJson.replaceAll(':','=');
                            dataJson = dataJson.replaceAll('"','');
                            dataJson = dataJson.replaceAll(',','&');

                            var optionJson = JSON.stringify(this.graph_rq_option);
                          /*  optionJson = optionJson.substring(1);
                            optionJson = optionJson.slice(0,-1);
                            optionJson = optionJson.replaceAll(':','=');
                            optionJson = optionJson.replaceAll('"','');
                            optionJson = optionJson.replaceAll(',','&');*/

                            this.axios({url: api.url + 'graph?' + dataJson + "&options=" + optionJson, method: 'GET' })
                            .then(function (resp) {                           
                                if(resp.status == 200){
                                    var i;
                                    this.data_avaible = true;

                                    var temp;
                                    if(this.selected_by == "systems"){

                                        this.options1.yaxis= [
                                            {
                                                seriesName: 'Temps d\'utilisation (h)',
                                                opposite: true,
                                                axisTicks: {
                                                    show: true,
                                                },
                                                axisBorder: {
                                                    show: true,
                                                    color: '#008FFB'
                                                },
                                                labels: {
                                                    style: {
                                                        colors: '#008FFB',
                                                    }
                                                },
                                                title: {
                                                    text: "Temps d'utilisation (h)",
                                                    style: {
                                                        color: '#008FFB',
                                                    }
                                                },
                                                decimalsInFloat : 2,
                                                min : 0,
                                                max : 100,
                                                forceNiceScale : true
                                            },
                                            {
                                                seriesName: resp.data['SValueABS_Title']+" ("+resp.data['SValueABS_UnitShort']+")",
                                                opposite: true,
                                                axisTicks: {
                                                    show: true,
                                                },
                                                axisBorder: {
                                                    show: true,
                                                    color: '#00E396'
                                                },
                                                labels: {
                                                    style: {
                                                        colors: '#00E396',
                                                    },
                                                },
                                                title: {
                                                    text: resp.data['SValueABS_Title']+" ("+resp.data['SValueABS_UnitShort']+")",
                                                    style: {
                                                        color: '#00E396',
                                                    }
                                                },
                                                decimalsInFloat : 2,
                                                min : 0,
                                                max : 100,
                                                forceNiceScale : true
                                            },
                                        ]

                                        this.series1 = [{
                                                name: 'Temps d\'utilisation',
                                                type: 'line',
                                                data: [],
                                                style: {
                                                    colors: '#00E396',
                                                }
                                            }, {
                                                name: resp.data['SValueABS_Title'],
                                                type: 'line',
                                                data: [],
                                                style: {
                                                    colors: '#FEB019',
                                                }
                                            }
                                        ];

                                        this.options1.xaxis.categories = [];
                                        this.options1.yaxis[0].min = Math.trunc(resp.data['time_use'][0]['TimeUse']/36)/100;
                                        this.options1.yaxis[0].max = Math.trunc(resp.data['time_use'][0]['TimeUse']/36)/100;
                                        for (temp of resp.data['time_use']){
                                            temp['TimeUse'] = Math.trunc(temp['TimeUse']/36)/100;
                                            if(temp['TimeUse']<this.options1.yaxis[0].min){
                                                this.options1.yaxis[0].min = temp['TimeUse'];
                                            }
                                            if(temp['TimeUse']>this.options1.yaxis[0].max){
                                                this.options1.yaxis[0].max = temp['TimeUse'];
                                            }
                                            this.series1[0].data.push({x :temp['SDate'], y:temp['TimeUse']});
                                        }
                                        if(this.system.display_unit.title == "4"){
                                            this.system.display_unit.factor = 1 
                                        }
                                        this.options1.yaxis[1].min = Math.trunc(resp.data['value_abs'][0]['SValueABS']/this.system.display_unit.factor*100)/100;
                                        this.options1.yaxis[1].max = Math.trunc(resp.data['value_abs'][0]['SValueABS']/this.system.display_unit.factor*100)/100;
                                        for (temp of resp.data['value_abs']){
                                            temp['SValueABS'] = Math.trunc(temp['SValueABS']/this.system.display_unit.factor*100)/100;
                                            if(temp['SValueABS']<this.options1.yaxis[1].min){
                                                this.options1.yaxis[1].min = temp['SValueABS'];
                                            }
                                            if(temp['SValueABS']>this.options1.yaxis[1].max){
                                                this.options1.yaxis[1].max = temp['SValueABS'];
                                            }
                                            this.series1[1].data.push({x :temp['SDate'], y:temp['SValueABS']});
                                        }

                                        //Maj de l'affichage des donut
                                        this.series2 = [];
                                        this.series2.push(resp.data['period_days']-resp.data['rent_days']);
                                        this.series2.push(resp.data['rent_days']);

                                        this.series3 = [];
                                        this.series3.push(Math.trunc((resp.data['rent_time']-resp.data['use_time_rent'])/36)/100);
                                        this.series3.push(Math.trunc(resp.data['use_time_rent']/36)/100);
                                        this.series3.push(Math.trunc(resp.data['use_time_off_rent']/36)/100);
                                    }
                                    else if(this.selected_by == "sensors"){

                                        this.options1.yaxis= [
                                            {
                                                seriesName: 'Temps d\'utilisation',
                                                opposite: true,
                                                axisTicks: {
                                                    show: true,
                                                },
                                                axisBorder: {
                                                    show: true,
                                                    color: '#008FFB'
                                                },
                                                labels: {
                                                    style: {
                                                        colors: '#008FFB',
                                                    }
                                                },
                                                title: {
                                                    text: "Temps d'utilisation (s)",
                                                    style: {
                                                        color: '#008FFB',
                                                    }
                                                },
                                                decimalsInFloat : 0,
                                                min : 0,
                                                max : 100,
                                                forceNiceScale : true
                                            },
                                            {
                                                seriesName: 'Valeur Absolue',
                                                opposite: true,
                                                axisTicks: {
                                                    show: true,
                                                },
                                                axisBorder: {
                                                    show: true,
                                                    color: '#00E396'
                                                },
                                                labels: {
                                                    style: {
                                                        colors: '#00E396',
                                                    },
                                                },
                                                title: {
                                                    text: "Valeur Absolue",
                                                    style: {
                                                        color: '#00E396',
                                                    }
                                                },
                                                decimalsInFloat : 0,
                                                min : 0,
                                                max : 100,
                                                forceNiceScale : true
                                            },
                                            {
                                                seriesName: 'Tension batterie',
                                                opposite: true,
                                                axisTicks: {
                                                    show: true,
                                                },
                                                axisBorder: {
                                                    show: true,
                                                    color: '#FEBB3B'
                                                },
                                                labels: {
                                                    style: {
                                                        colors: '#FEBB3B',
                                                    },
                                                },
                                                title: {
                                                    text: "Tension batterie",
                                                    style: {
                                                        color: '#FEBB3B',
                                                    }
                                                },
                                                decimalsInFloat : 2,
                                                min : 0,
                                                max : 100,
                                            },
                                            {
                                                seriesName: 'Valeur Analogique 1',
                                                opposite: true,
                                                axisTicks: {
                                                    show: true,
                                                },
                                                axisBorder: {
                                                    show: true,
                                                    color: '#FF4560'
                                                },
                                                labels: {
                                                    style: {
                                                        colors: '#FF4560',
                                                    },
                                                },
                                                title: {
                                                    text: "Valeur Analogique 1",
                                                    style: {
                                                        color: '#FF4560',
                                                    }
                                                },
                                                decimalsInFloat : 3,
                                                min : 0,
                                                max : 100,
                                            },
                                        ]

                                        this.series1 = [{
                                                name: 'Temps d\'utilisation',
                                                type: 'line',
                                                data: [],
                                                style: {
                                                    colors: '#00E396',
                                                }
                                            }, {
                                                name: 'Valeur Absolue',
                                                type: 'line',
                                                data: [],
                                                style: {
                                                    colors: '#FEB019',
                                                }
                                            }, 
                                            {
                                                name: 'Tension batterie',
                                                type: 'line',
                                                data: [],
                                                style: {
                                                    colors: '#FEBB3B,',
                                                }
                                            }, 
                                            {
                                                name: 'Valeur Analogique 1',
                                                type: 'line',
                                                data: [],
                                                style: {
                                                    colors: '#FF4560,',
                                                }
                                            }
                                        ];

                                        this.options1.xaxis.categories = [];

                                        this.options1.yaxis[0].min = resp.data['time_use'][0]['TimeUse'];
                                        this.options1.yaxis[0].max = resp.data['time_use'][0]['TimeUse'];
                                        for (temp of resp.data['time_use']){
                                            if(temp['TimeUse']<this.options1.yaxis[0].min){
                                                this.options1.yaxis[0].min = temp['TimeUse'];
                                            }
                                            if(temp['TimeUse']>this.options1.yaxis[0].max){
                                                this.options1.yaxis[0].max = temp['TimeUse'];
                                            }
                                            this.series1[0].data.push({x :temp['SDate'], y:temp['TimeUse']});
                                        }

                                        this.options1.yaxis[1].min = resp.data['value_abs'][0]['SValueABS'];
                                        this.options1.yaxis[1].max = resp.data['value_abs'][0]['SValueABS'];
                                        for (temp of resp.data['value_abs']){
                                            if(temp['SValueABS']<this.options1.yaxis[1].min){
                                                this.options1.yaxis[1].min = temp['SValueABS'];
                                            }
                                            if(temp['SValueABS']>this.options1.yaxis[1].max){
                                                this.options1.yaxis[1].max = temp['SValueABS'];
                                            }
                                            this.series1[1].data.push({x :temp['SDate'], y:temp['SValueABS']});
                                        }

                                        //this.options1.yaxis[2].min = resp.data['battery'][0]['BatteryLife'];
                                        //this.options1.yaxis[2].max = resp.data['battery'][0]['BatteryLife'];
                                        for (temp of resp.data['battery']){
                                          /*  if(temp['BatteryLife']<this.options1.yaxis[1].min){
                                                this.options1.yaxis[2].min = temp['BatteryLife'];
                                            }
                                            if(temp['BatteryLife']>this.options1.yaxis[1].max){
                                                this.options1.yaxis[2].max = temp['BatteryLife'];
                                            }*/
                                            this.series1[2].data.push({x :temp['SDate'], y:temp['BatteryLife']});
                                        }
                                        
                                        if(resp.data['ana_val1'].length>0){
                                            //this.options1.yaxis[3].min = (Math.trunc(resp.data['ana_val1'][0]['brut']/11.41*100)/100)-74.77;
                                            //this.options1.yaxis[3].max = (Math.trunc(resp.data['ana_val1'][0]['brut']/11.41*100)/100)-74.77;
                                            this.options1.yaxis[3].min = resp.data['ana_val1'][0]['brut']/1000;
                                            this.options1.yaxis[3].max = resp.data['ana_val1'][0]['brut']/1000;
                                            for (temp of resp.data['ana_val1']){
                                                temp['brut'] = temp['brut']/1000;
                                                if(temp['brut']<this.options1.yaxis[3].min){
                                                    this.options1.yaxis[3].min = temp['brut'];
                                                }
                                                if(temp['brut']>this.options1.yaxis[3].max){
                                                    this.options1.yaxis[3].max = temp['brut'];
                                                }
                                                this.series1[3].data.push({x :temp['SDate'], y:temp['brut']});
                                            }
                                        }
                                    }
    
                                    //GESTION des MIN MAX
                                    for(i=0; i<this.options1.yaxis.length; i++){
                                        this.options1.yaxis[i].min = Math.trunc(this.options1.yaxis[i].min*0.99)-1;
                                       // if(this.options1.yaxis[i].min < 0) this.options1.yaxis[i].min = 0;
                                        this.options1.yaxis[i].max = Math.trunc(this.options1.yaxis[i].max*1.01)+1;
                                    }
                                    if(this.selected_by == "sensors"){
                                        //différence pour les batteries
                                        this.options1.yaxis[2].min = 2.0;
                                        this.options1.yaxis[2].max = 4.4;
                                    }

                                    if(this.graph_rq_option.groupping_option != "without"){
                                        for(i=0; i<this.series1.length; i++){
                                            this.series1[i].type= 'column';
                                        }
                                    }
                                    else{
                                        for(i=0; i<this.series1.length; i++){
                                            this.series1[i].type= 'line';
                                        }
                                    }

                                    /*"without"
                                    "activity"
                                    "hourly"
                                    "daily"*/
                                }
                                else if(resp.status < 400){
                                    this.showAlert();
                                }
                                
                                this.isBusy=false;

                                //TODO gérer le passage des données reçues aux bonne variables
                            }.bind(this))
                           .catch(err => {
                               // console.log(err);
                                this.isBusy=false;    
                                this.$store.dispatch('extractions/getExtractions');                             
                            });

                            }
                        else {                            
                            this.error = true; 
                            this.isBusy=false;                           
                        //    console.log("pas d'abonnement");                                                       
                        }  
                        this.$store.dispatch('extractions/getExtractions');  
                    }.bind(this))
                    .catch((err) => {   
                        this.error = true; 
                        this.isBusy=false; 
                        this.$store.dispatch('extractions/getExtractions');
                    });
            },
            tooltipFormatter(value, opts) {
                //return opts.dateFormatter(new Date(timestamp), 'dd MMM');
                const moment = require('moment');

                //const date = moment();
                var date = new Date(value);
                
                if(this.graph_rq_option.groupping_option == "without"){
                    return date.toLocaleString('fr-FR', { day: "numeric", month:'short' }) +  moment(date).format(' HH:mm:ss');
                }
                else if(this.graph_rq_option.groupping_option == "activity"){
                    return date.toLocaleString('fr-FR', { day: "numeric", month:'short' }) +  moment(date).format(' HH:mm:ss');
                }
                else if(this.graph_rq_option.groupping_option == "hourly"){
                    return date.toLocaleString('fr-FR', { day: "numeric", month:'short' }) +  moment(date).format(' HH') +"h";
                }
                else if(this.graph_rq_option.groupping_option == "daily"){
                    return date.toLocaleString('fr-FR', { day: "numeric", month:'short' });
                }
            },
        },
    };
</script>